// extracted by css-extract-rspack-plugin
export default {"Box":"iteration-renderer-module__Box__bAlat","Label":"iteration-renderer-module__Label__sgGY2"};